import { ILoggedIn, RootState } from '@checkout/state';
import * as React from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { logOutRequest, toggleMembershipOverlay } from '../../../reducers/checkout';
import messages from './../../../i18n/base-en';
import * as Styles from './MembershipNav.scss';

interface IOwnProps {}

interface IConnectedProps {
  isMembershipOverlayOpen: boolean;
  loggedIn: ILoggedIn | null;
  accountPath: string;
}

interface IConnectetDispatchProps {
  toggleMembershipOverlay: typeof toggleMembershipOverlay;
  logOutRequest: typeof logOutRequest;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class MembershipNav extends React.Component<Props, {}> {

  handleClick = (event: React.MouseEvent<HTMLElement>) => {
    const { loggedIn, toggleMembershipOverlay: toggleOverlay, isMembershipOverlayOpen } = this.props;

    if (loggedIn == null) {
      toggleOverlay({ isOpen: !isMembershipOverlayOpen });
      event.preventDefault();
    }
  }

  handleLogout = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    this.props.logOutRequest();
  }

  render() {
    const { accountPath, loggedIn, intl } = this.props;
    const { formatMessage } = intl;
    const label = loggedIn === null ?
      formatMessage(messages.membership_login_button_label) : `${formatMessage(messages.membership_greeting)}, ${loggedIn.firstName}`;

    return (
      <Fragment>
        <a onClick={this.handleClick} href={accountPath}>{label}</a>
        {loggedIn && (
          <Fragment>
            <span className={Styles.separator} />
            <span className={Styles.logout} onClick={this.handleLogout}>{formatMessage(messages.membership_logout)}</span>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      isMembershipOverlayOpen: state.checkout.ui.membership.overlay.isOpen,
      loggedIn: state.checkout.loggedIn,
      accountPath: state.checkout.pathnames.account,
    }),
    {
      toggleMembershipOverlay,
      logOutRequest
    }
  )
)(MembershipNav);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/MembershipNav/MembershipNav.tsx